import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ index, label, className = "" }) => (
  <p
    className={`text-[11px] sm:text-xs font-medium uppercase tracking-[0.4em] text-amber ${className}`}
  >
    [ {index} ] — {label}
  </p>
);
